import { React } from "react";
import { newSessionUID } from "./commons";

// stretch: see MainBg2 - fill the container rather than scaling uniformly.
// frameless: see MainBg2.
export function MainBg({ isDarkMode = false, width = "100%", height = "100%", col = null, colEnd = null, stretch = false, frameless = false }) {
  const uName = newSessionUID()
  const sData = {
    // width:1305,
    // height:742,
    x:30,
    y:15,
    width:width=="100%"?1245:width - 60,
    height:height=="100%"?682:height - 60,
    rx:8,
    fill:`url(#lll_${uName})`,
    stroke:`url(#lll_${uName})`,
    strokeOpacity:0.1,
    vBox:"0 0 "+(width=="100%"?1305:width)+" "+(height=="100%"?742:height),
  }

  return (
    <div style={{
      zIndex: 1,
      position: "absolute",
      top: 0,
      left: 0,
      padding: 0,
      margin: 0,
      width: "100%",
      height: "100%",
    }}>
      <svg
        width={width}
        height={height}
        viewBox={sData.vBox}
        preserveAspectRatio={stretch ? "none" : undefined}
        fill="none"
      >
        <g filter={`url(#ddd_${uName})`}>
          <rect
            x={sData.x}
            y={sData.y}
            width={sData.width}
            height={sData.height}
            rx={sData.rx}
            fill={sData.fill} />
          <rect
            x={sData.x+0.5}
            y={sData.y+0.5}
            width={sData.width-1}
            height={sData.height-1}
            rx={sData.rx-0.5}
            stroke={sData.stroke}
            strokeOpacity={sData.strokeOpacity} />
          <rect
            x={sData.x+0.5}
            y={sData.y+0.5}
            width={sData.width-1}
            height={sData.height-1}
            rx={sData.rx-0.5}
            stroke={sData.stroke}
            style={{ mixBlendMode: "overlay" }} />
        </g>
        <defs>
          <filter
            id={`ddd_${uName}`}
            x={0}
            y={-5}
            width={sData.width + 60} 
            height={sData.height + 60}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha" />
            <feOffset dy={15} />
            <feGaussianBlur stdDeviation={15} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_9571_9252" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha" />
            <feOffset dy={2} />
            <feGaussianBlur stdDeviation={2} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend
              mode="normal"
              in2="effect1_dropShadow_9571_9252"
              result="effect2_dropShadow_9571_9252" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha" />
            <feOffset dy={3} />
            <feGaussianBlur stdDeviation={3} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
            <feBlend
              mode="normal"
              in2="effect2_dropShadow_9571_9252"
              result="effect3_dropShadow_9571_9252" />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect3_dropShadow_9571_9252"
              result="shape" />
          </filter>
          <clipPath id="bgblur_0_9571_9252_clip_path" transform="translate(0 5)">
            <rect x={sData.x} y={sData.y} width={sData.width} height={sData.height} rx={sData.rx} />
          </clipPath>
          <linearGradient
            id={`lll_${uName}`}
            x1="429.722"
            y1="14.9999"
            x2="464.381"
            y2="695.234"
            gradientUnits="userSpaceOnUse"
          >
            {isDarkMode ?
              <>
                <stop stopColor={col || "#202020"} />
                <stop offset={1} stopColor={colEnd || "#321B17"} />
              </>
              :
              <>
                <stop stopColor="hsl(0, 0%, 95%)" />
                <stop offset={1} stopColor="hsl(0, 0%, 88%)" />
              </>}
          </linearGradient>
          <linearGradient
            id="paint1_linear_9571_9252"
            x1="382.75"
            y1="435.567"
            x2="737.164"
            y2="-211.422"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={isDarkMode ? "white" : "black"} stopOpacity={0} />
            <stop offset={1} stopColor={isDarkMode ? "white" : "black"} />
          </linearGradient>
        </defs>

      </svg>
    </div>
  );
}
